import React, { forwardRef, useEffect, useState } from 'react';

const RBR_SLIDER_PORTAL_CONTAINER_ID = 'rbr-slider-portal-wrapper';

export const useRbrSliderPortalContainer = () => {
  const [container, setContainer] = useState<HTMLDivElement | null>(null);
  useEffect(() => {
    // Wait for the container div to be created
    const observer = new MutationObserver(() => {
      const el = document.getElementById(RBR_SLIDER_PORTAL_CONTAINER_ID);
      if (!el) return;
      setContainer(el as HTMLDivElement);
      observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });
    return () => observer.disconnect();
  }, []);

  return container;
};

export const RbrSliderPortalContainer = forwardRef(
  (props: Omit<React.HTMLAttributes<HTMLDivElement>, 'id'>, ref: React.LegacyRef<HTMLDivElement>) => (
    <div {...props} id={RBR_SLIDER_PORTAL_CONTAINER_ID} ref={ref} />
  ),
);
